<script lang="ts" setup>
import { XCircleIcon } from "@heroicons/vue/solid";

interface Meta {
    valid: boolean;
    touched: boolean;
}

interface Props {
    label?: string;
    name: string;
    errorMessage: string;
    meta: Meta;
    required?: boolean;
    labelPosition?: "top" | "left";
}

const props = withDefaults(defineProps<Props>(), {
    label: "",
    errorMessage: "",
    required: false,
    labelPosition: "top",
});
</script>

<template>
    <div :class="{ 'has-error': !!errorMessage, success: meta.valid }">
        <div class="flex" :class="{ 'flex-row items-center justify-between gap-[16px]': labelPosition === 'left', 'flex-col': labelPosition === 'top' }">
            <label :for="name" class="block text-sm font-medium" :class="{ '': labelPosition === 'left' || labelPosition === 'top' }">
                {{ label }}
                <span class="text-primary" v-if="required">*</span>
            </label>
            <slot></slot>
        </div>

        <Transition name="top-fade">
            <div class="mt-[4px] bg-red-100 p-[8px] rounded-[8px] flex items-center gap-[8px] z-[1]" v-if="errorMessage && meta.touched">
                <XCircleIcon class="h-[16px] fill-red-400"></XCircleIcon>
                <span class="text-12 font-semibold text-red-400">{{ errorMessage }}</span>
            </div>
        </Transition>
    </div>
</template>
